import { CLIENT_TEMP_ID_PREFIX } from "@common/schemas/chart-of-accounts-template-account.schema";

// Monotonic counter backing client temp ids. Temp ids only need to be unique
// within a single editing session (the backend assigns real uuids on save), so
// a per-session counter is sufficient and keeps ids human-readable in tests.
let tempIdCounter = 0;

export const createTempId = (): string => {
    tempIdCounter += 1;
    return `${CLIENT_TEMP_ID_PREFIX}${tempIdCounter}`;
};
